"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var home;
        (function (home) {
            var index;
            (function (index) {
                class InitArgs {
                    constructor() {
                        this.showSecurityReview = false;
                        this.handleSecurityViewResult = appn.emptyString;
                        this.providerSecurity = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                    if (_initArgs.showSecurityReview) {
                        $('#reviewSecurityDialog').modal('show');
                    }
                }
                index.init = init;
                function addEvents() {
                    $('#createform').click(function () {
                        appn.iframe.openModal({ url: 'Forms/Create?folderId=' });
                    });
                    $('#dismissSecureScore, #postponeSecureScore').on('click', function () {
                        let elementId = $(this).attr('id');
                        appn.ajax.post({
                            url: _initArgs.handleSecurityViewResult,
                            data: {
                                dismiss: elementId === "dismissSecureScore",
                                postpone: elementId === "postponeSecureScore"
                            },
                            always: function () {
                                $('#reviewSecurityDialog').modal('hide');
                            }
                        });
                    });
                    $('#doNotRemind').on('change', function () {
                        if ($(this).is(':checked')) {
                            $('.postpone').hideElement();
                            $('.dontRemind').showElement();
                        }
                        else {
                            $('.postpone').showElement();
                            $('.dontRemind').hideElement();
                        }
                    });
                    $('#reviewSecureScore').on('click', function () {
                        appn.ajax.post({
                            url: _initArgs.handleSecurityViewResult,
                            data: {
                                dismiss: true
                            },
                            always: function () {
                                appn.location.navTo(_initArgs.providerSecurity);
                            }
                        });
                    });
                }
            })(index = home.index || (home.index = {}));
        })(home = views.home || (views.home = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
